// @flow
'use strict';

import * as React from 'react';
import { FormSection } from 'redux-form/lib/immutable';

import SelecaoTodosNfe from '../../../form_exportacao_nfe/campos_nfe/selecao_todos_nfe';
import { Input } from '../../../../../../../common/input';

export default function CamposPisSt() {
  return (
      <FormSection name="dadosPisSt">
        <SelecaoTodosNfe nomes={ ["dadosPisSt"] } titulo="Dados do PIS ST"/>

        <div className="grupo-checkbox">
          <Input name="valorBcPisSt" label="Base Cálculo PIS" checkbox/>
          <Input name="aliquotaPercPisSt" label="Alíquota em Percentual" checkbox/>
          <Input name="qtdVendidaPisSt" label="Quantidade Vendida" checkbox/>
          <Input name="aliquotaReaisPisSt" label="Alíquota em Reais" checkbox/>
          <Input name="valorPisSt" label="Valor do PIS" checkbox/>
        </div>
      </FormSection>
  );
}